(function () {
  var STORAGE_KEY = 'nk-favorites';

  function getFavorites() {
    try {
      var favorites = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(favorites) ? favorites : [];
    } catch (error) {
      return [];
    }
  }

  function setFavorites(list) {
    var uniqueList = list.filter(function (handle, index) {
      return handle && list.indexOf(handle) === index;
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(uniqueList));

    document.dispatchEvent(
      new CustomEvent('nk:favorites-updated', {
        detail: uniqueList
      })
    );
  }

  function updateFavoriteCount() {
    var count = getFavorites().length;

    document
      .querySelectorAll('[data-nk-favorites-count]')
      .forEach(function (element) {
        element.textContent = count;
        element.hidden = count === 0;
      });
  }

  function updateFavoriteButtons() {
    var favorites = getFavorites();

    document
      .querySelectorAll('[data-nk-fav-toggle]')
      .forEach(function (button) {
        var handle = button.getAttribute('data-product-handle');
        var isFavorite = favorites.indexOf(handle) !== -1;

        button.classList.toggle('is-active', isFavorite);

        button.setAttribute(
          'aria-label',
          isFavorite
            ? 'Aus Favoriten entfernen'
            : 'Zu Favoriten hinzufügen'
        );
      });
  }

  function formatMoney(cents) {
    var currency =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'EUR';

    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function createProductCard(product) {
    var variants = Array.isArray(product.variants)
      ? product.variants
      : [];

    var variant =
      variants.find(function (item) {
        return item.available;
      }) || variants[0];

    var imageUrl = '';

    if (product.featured_image) {
      imageUrl =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src || '';
    }

    if (imageUrl.indexOf('//') === 0) {
      imageUrl = 'https:' + imageUrl;
    }

    var productUrl =
      product.url || '/products/' + product.handle;

    var card = document.createElement('article');

    card.className = 'nk-wishlist-card';
    card.setAttribute(
      'data-product-handle',
      product.handle
    );

    card.innerHTML =
      '<div class="nk-wishlist-card__media">' +

        '<a href="' +
          productUrl +
          '" class="nk-wishlist-card__image-link">' +

          (imageUrl
            ? '<img class="nk-wishlist-card__image" src="' +
                imageUrl +
                '" alt="' +
                escapeHtml(product.title) +
                '" loading="lazy">'
            : '') +

        '</a>' +

        '<button type="button" ' +
        'class="nk-wishlist-card__remove" ' +
        'data-nk-wishlist-remove="' +
        escapeHtml(product.handle) +
        '" aria-label="Aus Favoriten entfernen">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M12 20s-7-4.4-9.5-9C.8 7.8 2.6 4 6.3 4 8.5 4 10.5 5.3 12 7.5 13.5 5.3 15.5 4 17.7 4 21.4 4 23.2 7.8 21.5 11 19 15.6 12 20 12 20z"/>' +
        '</svg>' +
        '</button>' +

      '</div>' +

      '<div class="nk-wishlist-card__content">' +

        '<h2 class="nk-wishlist-card__title">' +
          '<a href="' + productUrl + '">' +
            escapeHtml(product.title) +
          '</a>' +
        '</h2>' +

        (product.description
          ? '<div class="nk-wishlist-card__sub">' +
              escapeHtml(product.description) +
            '</div>'
          : '') +

        '<div class="nk-wishlist-card__price">' +
          (product.price_varies ? 'Ab ' : '') +
          formatMoney(product.price) +
        '</div>' +

        (variant
          ? '<button type="button" ' +
              'class="nk-wishlist-card__add" ' +
              'data-nk-quickadd ' +
              'data-variant-id="' +
              variant.id +
              '"' +
              (variant.available ? '' : ' disabled') +
            '>' +
              (variant.available
                ? 'In den Warenkorb'
                : 'Ausverkauft') +
            '</button>'
          : '') +

      '</div>';

    return card;
  }

  function showEmptyState(grid, empty, loading) {
    loading.hidden = true;
    grid.hidden = true;
    empty.hidden = false;
  }

  function loadWishlist() {
    var grid = document.querySelector(
      '[data-nk-wishlist-grid]'
    );

    var empty = document.querySelector(
      '[data-nk-wishlist-empty]'
    );

    var loading = document.querySelector(
      '[data-nk-wishlist-loading]'
    );

    /*
     * Auf normalen Seiten existiert die Wishlist-Liste nicht.
     * Das Skript läuft dort trotzdem für Herz und Zähler weiter.
     */
    if (!grid || !empty || !loading) {
      return;
    }

    var favorites = getFavorites();

    grid.innerHTML = '';
    grid.hidden = true;
    empty.hidden = true;
    loading.hidden = false;

    if (!favorites.length) {
      showEmptyState(grid, empty, loading);
      return;
    }

    Promise.all(
      favorites.map(function (handle) {
        return fetch(
          '/products/' +
            encodeURIComponent(handle) +
            '?view=wishlist-json'
        )
          .then(function (response) {
            if (!response.ok) {
              throw new Error(
                'Produkt konnte nicht geladen werden'
              );
            }

            return response.json();
          })
          .catch(function (error) {
            console.error(
              'Wishlist-Produkt konnte nicht geladen werden:',
              handle,
              error
            );

            return null;
          });
      })
    ).then(function (products) {
      var validProducts = products.filter(Boolean);

      loading.hidden = true;

      if (!validProducts.length) {
        showEmptyState(grid, empty, loading);
        return;
      }

      validProducts.forEach(function (product) {
        grid.appendChild(createProductCard(product));
      });

      grid.hidden = false;
      empty.hidden = true;

      var validHandles = validProducts.map(function (product) {
        return product.handle;
      });

      if (validHandles.length !== favorites.length) {
        setFavorites(validHandles);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var favoriteButton = event.target.closest(
      '[data-nk-fav-toggle]'
    );

    if (!favoriteButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var handle = favoriteButton.getAttribute(
      'data-product-handle'
    );

    if (!handle) {
      return;
    }

    var favorites = getFavorites();
    var index = favorites.indexOf(handle);

    if (index !== -1) {
      favorites.splice(index, 1);
    } else {
      favorites.push(handle);
    }

    setFavorites(favorites);
  });

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest(
      '[data-nk-wishlist-remove]'
    );

    if (!removeButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var handle = removeButton.getAttribute(
      'data-nk-wishlist-remove'
    );

    var favorites = getFavorites().filter(function (item) {
      return item !== handle;
    });

    setFavorites(favorites);
  });

  function initializeFavorites() {
    updateFavoriteButtons();
    updateFavoriteCount();
    loadWishlist();
  }

  document.addEventListener(
    'DOMContentLoaded',
    initializeFavorites
  );

  document.addEventListener(
    'nk:favorites-updated',
    function () {
      updateFavoriteButtons();
      updateFavoriteCount();
      loadWishlist();
    }
  );
})();